import { Stack } from '@mui/material'
import React, { FC, useContext } from 'react'

import { Page } from '../../components'
import { RepairOrderProvider } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import { SingleInspectionContext } from '../../providers/SingleInspectionProvider/SingleInspectionProvider'
import BodyContainer from './BodyContainer'
import HeadingBox from './HeadingBox'

const SingleInspection: FC = () => {
  const { repairOrder } = useContext(SingleInspectionContext)
  const repairOrderId = repairOrder?.entry?.id

  return (
    <Page title="Inspection Details">
      {repairOrderId && (
        <RepairOrderProvider id={repairOrderId}>
          <Stack direction="column" spacing={2}>
            <HeadingBox />
            <BodyContainer />
          </Stack>
        </RepairOrderProvider>
      )}
    </Page>
  )
}

export default SingleInspection
